// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__RYwas","disabled":"FileBtn_disabled__2jK0t","warn":"FileBtn_warn__2ADG9","fade":"FileBtn_fade__2wcpY"};